<template>
  <div class="bq-product-zhgl">
    <div class="bq-product-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-product-title-wrap" :class="animateTitle">
          <div
            class="bq-product-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div class="bq-product-subtitle">
            构建于先进技术的数据仓库之上，解决医院管理者的数据需求。形成基础指标体系，可视化界面，分析决策主题的全方位分析平台
          </div>
        </div>
      </div>
    </div>
    <div class="bq-zhgl-content">
      <SectionTitle :title="'扁鹊智慧管理平台'" noSpacing></SectionTitle>
      <div class="zhgl-desc">
        构建于先进技术的数据仓库之上，解决医院管理者的数据需求。形成基础指标体系，可视化界面，分析决策主题的全方位分析平台。
      </div>
      <div class="wisdom">
        <div class="wisdom-title">
          <div
            class="wisdom-title-item"
            v-for="(item, idx) in wisdomList"
            :key="idx"
          >
            <div class="wisdom-title-item-icon"></div>
            <div class="wisdom-title-item-text">{{ item }}</div>
          </div>
        </div>
        <div class="wisdom-content">
          <div class="content-support">
            <div class="content-support-title">支持平台</div>
            <div class="content-support-item">Quick BI</div>
            <div class="content-support-item">DataV</div>
            <div class="content-support-item">自开部分</div>
          </div>
          <div class="content-support">
            <div class="content-support-title">数据管理体系</div>
            <div class="content-support-item">业务权限控制</div>
            <div class="content-support-item">业务权限控制</div>
            <div class="content-support-item">业务权限控制</div>
          </div>
          <div class="base-support">
            <div class="content-support-title">基础库</div>
            <div class="base-support-lib">
              <div
                class="lib-item"
                v-for="(item, index) in libList"
                :key="index"
              >
                <div class="lib-item-icon"></div>
                <div class="lib-item-desc">{{ item }}</div>
              </div>
            </div>
            <div class="base-support-long">决策支持的基础</div>
            <div class="base-support-long">数据挖掘</div>
          </div>
        </div>
        <div class="content-support-bottom">
          <div class="bottom-content">
            <div class="bottom-icon"></div>
            <div class="bottom-text">数据仓库</div>
          </div>
        </div>
      </div>
      <SectionTitle :title="'基础指标平台'" noSpacing></SectionTitle>
      <div class="zhgl-desc">
        形成涵盖医疗质量，医院运营等基础指标体系，基于基础指标构建专题分析和独立的科室分析工具。
      </div>
      <div class="target">
        <div class="target-title">
          <div>指标分析（指标组合形成报表）</div>
          <div>专题分析</div>
          <div>各科室独立的数据分析工具</div>
        </div>
        <div class="target-content">
          <div class="target-content-left">
            <div class="target-content-left-report">
              <div
                class="report-item"
                v-for="(item, idx) in reportList"
                :key="idx"
              >
                {{ item }}
              </div>
            </div>
            <div class="target-content-left-arrow">
              <div class="left-arrow-item"></div>
              <div class="left-arrow-item"></div>
              <div class="left-arrow-item"></div>
            </div>
            <div class="target-content-left-special">
              <div
                class="special-item"
                v-for="(item, idx) in specialList"
                :key="idx"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="target-content-arrow"></div>
          <div class="target-content-right">
            <div class="right-content">
              <img
                class="right-content-item"
                v-for="(item, idx) in toolList"
                :src="item"
                :key="idx"
              />
            </div>
          </div>
        </div>
      </div>
      <SectionTitle :title="'报表平台'" noSpacing></SectionTitle>
      <div class="zhgl-desc">
        可视化的平台，支持PC和移动端的无缝衔接。支持多维度图表，下钻，权限管控等。支持指标数据的推送，异常值提醒等功能。
      </div>
      <div class="quick-bi"></div>
      <SectionTitle :title="'决策分析平台'" noSpacing></SectionTitle>
      <div class="zhgl-desc">
        与国内先进的医院管理机构进行合作，引入先进的管理方法论体系。为医院持续改进管理水平做出贡献。
      </div>
      <div class="decision">
        <div class="decision-left"></div>
        <div class="decision-content">
          <div class="content-item">人次预测模型</div>
          <div class="content-item">PDCA管理</div>
          <div class="content-item">TPS BestFTQ-1</div>
          <div class="content-arrow"></div>
          <div class="content-item">方法论</div>
        </div>
        <div class="decision-right">扁鹊医院管理平台</div>
      </div>
      <SectionTitle :title="'大屏平台'" noSpacing></SectionTitle>
      <div class="large-screen">
        <el-carousel
          :interval="4000"
          :autoplay="false"
          height="358px"
          type="card"
        >
          <el-carousel-item v-for="item in imgList" :key="item">
            <img :src="item" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <SectionTitle :title="'数据预警与推送平台'" noSpacing></SectionTitle>
      <div class="zhgl-desc">
        允许用户定义指标预警值，允许用户订阅报表。可以通过钉钉、短信和邮件等方式通知到用户。
      </div>
      <div class="bq-advantage">
        <InfoBox
          :itemObj="item"
          :col="2"
          v-for="item in advantageList"
          :key="item.advTitles"
          :classes="'advantage'"
        ></InfoBox>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'Zhgl',
  components: {
    SectionTitle,
    InfoBox,
  },
  data() {
    return {
      animateTitle: [],
      titlebg:
        'https://img.alicdn.com/tfs/TB1ErLtD1L2gK0jSZPhXXahvXXa-313-51.png',
      cover:
        'https://img.alicdn.com/tfs/TB1hQuyE7T2gK0jSZPcXXcKkpXa-1920-380.png',
      wisdomList: [
        '基础报表平台',
        '大屏平台',
        '决策支持平台',
        '数据填上报平台',
        '数据预警与日报推送平台',
      ],
      libList: ['方法库', '模型库', '知识库', '基础指标库'],
      reportList: [
        '资产总量',
        '净资产总量',
        '人均成本',
        '非药材收入',
        '收支结余',
        '职工人均门诊人次',
        '业务收入',
        '总收入',
        '百元耗材',
        '财政补助',
        '人员经费支出比',
        '出诊人次',
        '开放床位数',
        '出院人次',
        '挂号量',
        '平均住院日',
        '预约量',
        '人均产值',
        '门诊均次费用',
        '项目补助',
        '住院手术人次',
        '出院人次',
        '门诊人次',
        '药比、耗比',
        '床日护理费',
        '医疗纯收入占比',
        '······',
      ],
      specialList: [
        '医护比优化分析',
        '科室号源排放分析',
        '降低退号率分析',
        '诊间合理利用分析',
        '预约率提升分析',
        '医院经济晴雨分析',
        '······',
      ],
      toolList: [
        'https://img.alicdn.com/tfs/TB1oG.oDQL0gK0jSZFAXXcA9pXa-168-378.png',
        'https://img.alicdn.com/tfs/TB1ekkpDQY2gK0jSZFgXXc5OFXa-168-378.png',
        'https://img.alicdn.com/tfs/TB1xNcpDO_1gK0jSZFqXXcpaXXa-168-378.png',
        'https://img.alicdn.com/tfs/TB1l0gmDUz1gK0jSZLeXXb9kVXa-168-378.png',
        'https://img.alicdn.com/tfs/TB1afZsDQT2gK0jSZFkXXcIQFXa-168-378.png',
        'https://img.alicdn.com/tfs/TB1MWoxDRr0gK0jSZFnXXbRRXXa-168-378.png',
      ],
      advantageList: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1MJZrDLb2gK0jSZK9XXaEgFXa-84-72.png',
          advTitles: '推送报表',
          advDesc: '订阅之后，推送报表日报周报等',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1Io7rDND1gK0jSZFsXXbldVXa-92-72.png',
          advTitles: '推送预警',
          advDesc: '定制指标阈值，实时推送预警。',
        },
      ],
      imgList: [
        // 'https://img.alicdn.com/tfs/TB1Y9mhF5_1gK0jSZFqXXcpaXXa-1200-714.png',
        // 'https://img.alicdn.com/tfs/TB1FxaeFVT7gK0jSZFpXXaTkpXa-1056-622.png',
        // 'https://img.alicdn.com/tfs/TB11rHubicKOu4jSZKbXXc19XXa-1056-622.png',
        'https://img.alicdn.com/tfs/TB1Z4gnF4D1gK0jSZFKXXcJrVXa-1200-714.png',
        'https://img.alicdn.com/tfs/TB197glF.T1gK0jSZFhXXaAtVXa-1200-714.png',
        'https://img.alicdn.com/tfs/TB1Y5inhIKfxu4jSZPfXXb3dXXa-1200-712.png',
        'https://img.alicdn.com/tfs/TB1KoQtF8r0gK0jSZFnXXbRRXXa-1200-712.png',
        'https://img.alicdn.com/tfs/TB18uEpF1H2gK0jSZJnXXaT1FXa-1200-712.png',
        'https://img.alicdn.com/tfs/TB1lccpF7T2gK0jSZFkXXcIQFXa-1200-714.png',
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="less" scoped>
@import './index.less';
</style>
